import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 720.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,720.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5105 6390 c-3 -10 -20 -15 -48 -16 -45 -2 -119 -26 -377 -123 -319
-121 -479 -212 -519 -294 -24 -49 -26 -73 -10 -114 30 -80 162 -157 404 -235
110 -35 353 -108 360 -108 4 0 -9 12 -30 26 -93 63 -107 110 -51 171 39 43 72
61 321 171 235 104 374 171 355 172 -8 0 -26 3 -40 7 -22 6 -24 5 -11 -10 8
-11 9 -17 3 -17 -6 0 -16 9 -22 21 -6 11 -21 24 -33 29 -21 8 -21 9 5 9 55 2
42 28 -26 52 -21 8 -42 23 -46 34 -4 11 -24 34 -43 51 -20 16 -41 42 -48 57
-7 15 -16 27 -21 27 -4 0 -8 9 -8 19 0 13 -15 26 -47 41 -27 12 -51 27 -55 33
-5 8 -9 7 -13 -3z"
          />
          <path
            d="M5614 6084 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30
-16z"
          />
          <path
            d="M5460 6071 c0 -5 12 -12 26 -15 30 -8 54 7 33 19 -8 5 -10 4 -5 -3 9
-15 5 -15 -28 -2 -14 5 -26 6 -26 1z"
          />
          <path d="M5540 6050 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M5832 5941 c-11 -7 -11 -9 0 -14 9 -3 15 1 15 9 0 8 -1 14 -1 14 -1
0 -7 -4 -14 -9z"
          />
          <path
            d="M5735 5890 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M5790 5869 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M5724 5857 c-2 -7 -3 -113 -2 -237 l3 -224 105 -33 c58 -18 108 -33
113 -33 4 0 7 115 7 255 0 215 -2 255 -14 255 -8 0 -18 -4 -21 -10 -9 -15 -53
-12 -81 6 -17 11 -37 15 -63 11 -31 -4 -38 -2 -34 9 3 8 2 14 -1 14 -4 0 -9
-6 -12 -13z"
          />
          <path
            d="M6051 5585 l-1 -290 109 -37 c59 -21 111 -38 115 -38 3 0 6 145 6
323 -1 258 -3 318 -13 300 -11 -20 -19 -21 -100 -20 -52 1 -87 -2 -88 -8 0 -5
-7 6 -14 25 -12 31 -14 -1 -14 -255z"
          />
          <path
            d="M6381 5514 l-1 -332 58 -23 c31 -12 83 -35 114 -51 32 -15 60 -28 63
-28 7 0 4 554 -4 670 -4 63 -9 88 -14 73 -7 -20 -37 -41 -37 -25 0 4 -27 5
-61 4 -74 -5 -106 3 -112 26 -3 9 -5 -132 -6 -314z"
          />
          <path
            d="M5585 5820 c-2 -4 -45 -24 -94 -45 l-90 -37 -3 -115 c-2 -63 0 -119
3 -125 5 -8 190 -68 211 -68 4 0 8 89 8 198 0 172 -2 199 -15 199 -9 0 -18 -3
-20 -7z"
          />
          <path
            d="M5345 5330 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"
          />
          <path
            d="M5370 5310 c-12 -8 -11 -10 5 -9 11 1 31 5 45 9 24 8 24 8 -5 9 -16
0 -37 -4 -45 -9z"
          />
          <path
            d="M5470 5290 c-14 -4 -19 -8 -11 -9 11 -1 11 -4 1 -16 -7 -8 -18 -15
-25 -15 -25 0 -45 -36 -45 -83 0 -43 2 -47 25 -47 23 0 25 -4 25 -40 0 -29 -4
-40 -15 -40 -11 0 -15 -11 -15 -40 0 -29 4 -40 15 -40 11 0 15 -11 15 -40 0
-29 -4 -40 -15 -40 -10 0 -15 -10 -15 -29 0 -16 -3 -37 -6 -46 -5 -13 -2 -15
19 -10 32 9 60 -5 31 -15 -16 -6 -13 -8 14 -15 22 -4 38 -3 45 5 9 9 5 10 -17
4 -19 -4 -27 -3 -23 3 4 6 18 13 32 15 13 3 22 1 19 -3 -3 -5 3 -9 12 -9 16 0
16 -1 -2 -16 -18 -14 -16 -15 24 -9 29 3 41 2 37 -5 -3 -5 1 -10 10 -10 8 0
23 -4 33 -10 17 -9 185 -61 212 -65 8 -2 50 -14 92 -29 43 -14 85 -23 94 -19
12 4 15 3 10 -5 -4 -7 -2 -12 6 -12 7 0 56 -16 108 -36 52 -20 111 -42 130
-50 19 -7 34 -18 33 -23 -3 -10 17 -16 39 -12 4 0 10 -8 13 -19 4 -11 11 -20
17 -20 5 0 8 7 5 14 -4 9 -1 13 6 10 7 -2 19 18 30 53 11 32 30 77 43 99 13
23 25 60 26 82 2 22 4 39 6 37 7 -7 52 44 52 59 0 10 4 14 10 11 7 -4 7 3 0
22 l-10 28 21 -25 22 -25 -7 25 c-7 24 -6 24 8 6 10 -12 16 -15 16 -7 0 18
-92 104 -154 146 -55 36 -141 77 -246 118 -117 46 -210 77 -210 71 0 -4 -6 -2
-12 4 -21 17 -278 92 -332 97 -45 4 -80 11 -151 28 -11 3 -31 2 -45 -3z m47
-6 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
          />
          <path d="M5578 5293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5068 4853 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M5359 4765 c-3 -2 -86 -29 -185 -59 -163 -50 -417 -140 -504 -180
-33 -14 -34 -16 -12 -22 12 -3 22 -10 22 -14 0 -4 19 -17 43 -28 24 -11 66
-43 94 -71 28 -28 58 -51 65 -51 8 0 21 -12 28 -26 8 -14 22 -30 32 -35 10 -5
18 -18 18 -27 0 -10 9 -25 20 -35 11 -9 20 -23 20 -31 0 -8 9 -18 20 -21 11
-3 20 -13 20 -21 0 -8 7 -17 15 -20 8 -4 13 -9 10 -13 -2 -4 10 -15 26 -25 33
-20 33 -34 1 -17 -31 16 -51 13 -22 -4 14 -8 19 -14 11 -15 -8 0 -12 -2 -9 -5
2 -3 58 9 124 26 142 36 343 75 668 130 285 47 352 62 427 91 95 36 115 108
46 161 -83 63 -388 171 -736 262 -213 55 -234 59 -242 50z m-617 -247 c-9 -9
-15 -9 -24 0 -9 9 -7 12 12 12 19 0 21 -3 12 -12z m-42 -8 c0 -5 -7 -7 -15 -4
-8 4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z"
          />
          <path d="M4610 4506 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path
            d="M6510 4419 c0 -6 -7 -9 -15 -5 -8 3 -14 0 -12 -7 1 -7 -4 -11 -11 -9
-8 1 -11 -2 -7 -8 4 -6 15 -4 31 6 21 15 33 34 19 34 -3 0 -5 -5 -5 -11z"
          />
          <path
            d="M6409 4380 c26 -22 37 -25 46 -10 3 6 -1 7 -10 4 -10 -4 -15 -2 -13
7 2 8 -7 15 -22 17 l-25 3 24 -21z"
          />
          <path d="M5038 4053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5028 4033 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M4990 4020 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M4360 3651 c-6 -11 -10 -90 -10 -185 l0 -166 -325 0 -325 0 -2 173
-3 172 -145 3 c-80 1 -155 0 -167 -3 l-23 -5 0 -473 c0 -355 3 -476 12 -485
17 -17 299 -17 316 0 8 8 12 66 12 195 l0 183 325 0 325 0 0 -179 c0 -150 3
-182 16 -195 13 -13 41 -16 155 -16 78 0 149 5 160 10 18 10 19 26 19 488 0
359 -3 481 -12 490 -8 8 -59 12 -165 12 -140 0 -153 -2 -163 -19z"
          />
          <path
            d="M5102 3659 c-110 -21 -223 -102 -268 -191 -31 -61 -44 -151 -44 -313
0 -209 27 -295 118 -377 53 -48 106 -74 184 -93 91 -21 685 -21 776 0 128 30
222 102 271 205 26 54 26 58 26 285 l0 230 -27 52 c-40 75 -79 115 -146 151
-109 58 -141 62 -512 61 -184 -1 -354 -5 -378 -10z m641 -243 c18 -7 43 -26
57 -40 24 -27 25 -33 28 -191 4 -186 -2 -207 -65 -247 -36 -22 -48 -23 -248
-27 -134 -2 -228 1 -261 8 -59 13 -99 50 -114 102 -13 46 -13 271 1 306 14 37
47 73 84 89 44 19 473 20 518 0z"
          />
          <path
            d="M6552 3655 c-74 -16 -169 -72 -212 -123 -60 -73 -73 -127 -78 -332
-6 -255 13 -324 112 -421 45 -44 101 -73 181 -94 89 -23 930 -23 963 1 22 15
22 17 22 294 0 240 -2 281 -16 294 -13 14 -56 16 -315 16 -358 0 -339 7 -339
-117 0 -43 5 -85 10 -93 7 -12 42 -16 167 -20 l158 -5 3 -49 c2 -27 1 -60 -3
-73 l-5 -23 -209 0 c-240 0 -303 9 -343 47 -41 39 -50 89 -46 238 3 114 6 134
26 166 40 66 59 69 433 69 210 0 337 4 350 10 15 9 109 175 109 194 0 3 -7 12
-16 20 -14 14 -68 16 -452 15 -329 0 -453 -4 -500 -14z"
          />
          <path
            d="M7657 3652 c-13 -14 -17 -38 -17 -103 0 -46 5 -91 10 -99 8 -13 60
-16 335 -20 l325 -5 -158 -140 c-87 -77 -235 -207 -330 -289 -163 -142 -172
-152 -178 -193 -8 -57 3 -110 26 -123 12 -6 231 -10 613 -10 497 0 596 2 606
14 8 9 11 50 9 117 l-3 104 -364 5 -364 5 174 155 c209 187 431 383 482 427
34 30 37 37 37 86 0 94 46 87 -612 87 -544 0 -576 -1 -591 -18z"
          />
          <path
            d="M2143 3631 c-129 -44 -201 -152 -191 -285 13 -152 121 -249 306 -276
37 -5 193 -10 347 -10 316 0 325 -2 325 -65 0 -65 2 -65 -440 -66 -217 0 -417
-4 -445 -7 l-50 -7 -54 -106 c-34 -65 -52 -112 -48 -122 6 -16 50 -17 530 -17
432 0 533 3 580 15 160 42 252 142 264 291 12 142 -63 256 -202 304 -67 23
-82 24 -399 27 -362 4 -366 4 -366 64 0 58 7 59 416 59 205 0 380 3 389 6 21
9 106 179 99 199 -5 13 -64 15 -508 15 -454 -1 -506 -2 -553 -19z"
          />
          <path
            d="M2280 2447 c0 -25 4 -34 18 -34 93 1 102 -2 102 -31 0 -26 3 -28 33
-27 17 1 38 -2 45 -8 9 -7 12 -2 12 22 0 25 -4 31 -20 31 -12 0 -35 7 -51 16
-17 8 -45 14 -62 13 -56 -4 -68 0 -65 19 2 9 10 20 18 24 11 5 9 7 -7 7 -19 1
-23 -4 -23 -32z"
          />
          <path
            d="M2455 2466 c30 -8 44 -15 35 -18 -8 -4 1 -7 20 -7 26 -1 31 2 20 9
-12 8 -10 10 10 11 l25 1 -25 8 c-14 4 -50 8 -80 8 l-55 0 50 -12z"
          />
          <path
            d="M2580 2476 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"
          />
          <path
            d="M2852 2438 l1 -43 4 39 c4 37 5 38 19 17 9 -12 20 -18 27 -14 20 12
55 14 62 3 4 -6 -6 -10 -24 -10 -17 0 -31 -4 -31 -10 0 -5 -7 -10 -15 -10 -13
0 -14 -2 -3 -14 11 -12 14 -12 19 2 4 12 19 15 67 13 39 -1 62 2 62 8 0 6 -15
11 -32 12 -28 0 -30 2 -13 9 19 8 19 9 -2 9 -12 1 -30 4 -40 8 -16 6 -15 8 7
14 21 6 19 7 -13 8 -23 1 -36 -3 -32 -9 3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10
0 6 -11 10 -25 10 -23 0 -25 -3 -23 -42z"
          />
          <path
            d="M3105 2470 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M3370 2324 c0 -85 4 -153 9 -150 12 8 13 306 1 306 -6 0 -10 -63 -10
-156z"
          />
          <path
            d="M3400 2467 c0 -17 52 -16 58 1 2 8 -8 12 -27 12 -19 0 -31 -5 -31
-13z"
          />
          <path
            d="M3872 2300 c0 -113 4 -190 10 -197 11 -14 42 -18 35 -5 -3 4 51 7
119 7 68 0 124 3 124 8 0 4 -29 7 -65 7 -36 0 -65 4 -65 8 0 4 -17 8 -37 9
-33 1 -35 0 -13 -7 24 -8 24 -8 -5 -9 -17 -1 -36 4 -43 11 -9 9 -15 8 -27 -8
-14 -19 -14 -19 -15 1 0 11 9 26 20 33 12 7 17 18 13 29 -5 12 -2 15 10 10 12
-5 17 1 19 26 3 30 5 32 39 29 43 -3 93 14 84 28 -4 6 5 10 20 10 20 0 26 -4
21 -15 -3 -8 -1 -15 4 -15 6 0 10 9 10 20 0 15 -7 20 -27 21 l-28 1 30 8 c22
6 8 8 -48 8 -43 -1 -80 -5 -84 -11 -3 -5 6 -7 23 -5 16 3 23 3 15 0 -11 -3
-11 -6 -2 -12 9 -5 8 -9 -4 -13 -9 -4 -13 -3 -10 3 3 6 -3 10 -14 10 -15 0
-21 7 -22 23 -1 20 -2 20 -6 2 -2 -11 -6 -30 -9 -42 -2 -13 -8 -23 -13 -23 -5
0 -7 10 -5 23 3 12 -1 8 -10 -12 -9 -18 -17 -50 -17 -70 -1 -24 -5 -13 -11 33
-9 62 -2 139 9 109 8 -23 35 -15 28 7 -5 15 -3 18 9 14 9 -3 16 -1 16 5 0 6
-9 11 -20 11 -12 0 -20 7 -21 18 0 14 -2 14 -9 -3 -8 -21 -8 -19 -24 75 -2 14
-4 -58 -4 -160z"
          />
          <path
            d="M3893 2460 c2 -11 7 -23 12 -27 4 -5 5 -2 1 5 -5 9 -1 15 13 19 29 7
26 23 -4 23 -19 0 -24 -5 -22 -20z"
          />
          <path
            d="M4045 2470 c8 -13 45 -13 65 0 11 7 3 10 -28 10 -26 0 -41 -4 -37
-10z"
          />
          <path
            d="M4500 2469 c-61 -25 -129 -101 -116 -132 2 -7 5 -3 6 8 2 17 3 16 10
-5 8 -25 8 -25 9 -2 1 13 6 20 11 17 6 -4 10 6 10 23 0 16 9 37 20 47 11 10
20 14 20 8 0 -12 58 -4 66 9 4 6 -6 8 -27 4 -25 -4 -29 -4 -14 3 11 5 36 10
55 11 29 1 32 3 15 10 -26 11 -35 11 -65 -1z"
          />
          <path
            d="M4610 2466 c8 -7 30 -16 49 -20 29 -5 32 -4 21 9 -7 9 -19 14 -27 11
-7 -3 -13 -1 -13 4 0 6 -10 10 -22 10 -19 0 -20 -2 -8 -14z"
          />
          <path
            d="M5105 2469 c17 -5 47 -7 67 -4 32 4 37 3 32 -12 -4 -13 -3 -14 3 -5
5 7 18 10 29 7 12 -4 10 -1 -6 9 -16 10 -48 15 -90 15 -56 -1 -61 -2 -35 -10z"
          />
          <path
            d="M5591 2315 c0 -93 3 -163 6 -155 12 31 42 39 44 13 1 -12 4 -10 9 7
l8 25 1 -27 c1 -16 -3 -28 -9 -28 -5 0 -10 -5 -10 -11 0 -5 5 -7 10 -4 6 3 10
2 10 -4 0 -5 -4 -13 -10 -16 -15 -9 -12 -22 5 -22 12 0 15 16 15 78 0 82 -8
100 -30 69 -22 -31 -35 -2 -38 88 -3 82 -3 84 19 77 15 -5 19 -4 14 4 -4 7 -2
18 5 26 8 10 8 15 0 20 -7 4 -14 -2 -17 -14 -3 -12 -10 -21 -15 -21 -5 0 -7 8
-4 18 3 9 1 24 -4 32 -6 10 -9 -43 -9 -155z"
          />
          <path d="M5650 2471 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
          <path
            d="M5928 2438 c-27 -42 -28 -71 -2 -61 11 4 12 9 5 16 -7 7 -7 16 1 30
6 13 13 16 17 9 4 -7 14 1 26 21 15 25 15 29 3 19 -10 -8 -17 -9 -20 -3 -1 6
-15 -8 -30 -31z"
          />
          <path
            d="M6012 2448 c-10 -27 -14 -30 -22 -18 -6 9 -10 10 -10 3 0 -6 7 -18
15 -27 11 -10 15 -37 15 -96 0 -46 -4 -79 -9 -76 -5 3 -9 -10 -9 -30 0 -19 -3
-38 -7 -42 -8 -9 -1 117 9 139 5 10 2 16 -8 16 -8 0 -15 -7 -14 -16 1 -9 0
-45 -1 -81 -2 -47 -5 -59 -11 -45 -8 19 -9 19 -9 -2 -1 -19 3 -22 29 -19 16 2
27 -1 24 -5 -3 -5 2 -9 10 -9 14 0 16 23 16 170 0 94 -1 170 -3 170 -1 0 -8
-15 -15 -32z"
          />
          <path
            d="M6342 2463 c-37 -18 -56 -43 -66 -85 -10 -43 9 -33 23 12 7 23 18 40
26 40 8 0 15 4 15 8 0 5 15 16 33 25 17 8 25 16 17 16 -8 0 -30 -7 -48 -16z"
          />
          <path
            d="M6440 2470 c-8 -5 -11 -12 -7 -17 5 -4 12 -1 16 6 6 8 19 12 35 9 14
-3 23 -1 20 3 -7 12 -45 11 -64 -1z"
          />
          <path d="M7164 2355 c0 -71 1 -99 3 -62 2 37 2 96 0 130 -2 34 -3 4 -3 -68z" />
          <path
            d="M7200 2471 c0 -14 28 -21 34 -8 5 10 3 -107 -5 -286 0 -9 -4 -15 -9
-12 -5 3 -11 1 -15 -5 -4 -6 23 -10 75 -10 48 0 79 -4 75 -9 -3 -6 14 -12 37
-14 37 -3 35 -4 -17 -6 -53 -2 -57 -4 -35 -13 14 -6 42 -12 63 -12 36 -2 37
-1 37 31 l0 33 -84 0 c-46 0 -91 2 -98 5 -11 4 -13 36 -10 160 l4 155 -26 0
c-14 0 -26 -4 -26 -9z"
          />
          <path
            d="M7590 2470 c0 -13 11 -13 30 0 12 8 11 10 -7 10 -13 0 -23 -4 -23
-10z"
          />
          <path
            d="M7700 2469 c14 -4 19 -7 11 -8 -11 -1 -10 -4 4 -14 16 -12 12 -15
-38 -20 -30 -4 -63 -4 -73 0 -12 4 -15 3 -10 -6 5 -7 26 -12 50 -11 85 4 86 3
87 -37 l2 -38 7 35 c7 33 7 33 9 6 1 -20 5 -27 16 -23 21 9 24 -3 15 -63 l-8
-55 -2 45 c-2 38 -3 41 -10 20 -4 -14 -8 -47 -8 -75 0 -27 2 -42 5 -33 4 15 7
16 17 5 7 -7 15 -19 19 -27 3 -8 6 40 6 108 l1 123 -30 6 c-32 6 -42 32 -12
34 46 3 115 -1 120 -5 3 -4 -12 -6 -34 -7 -31 0 -35 -2 -19 -9 11 -5 37 -9 58
-9 36 -1 37 0 37 34 0 26 -3 33 -15 29 -8 -4 -12 -10 -9 -15 6 -10 -36 -12
-60 -3 -9 3 -14 9 -11 13 2 5 -30 8 -73 8 -49 0 -68 -3 -52 -8z"
          />
          <path
            d="M8201 2472 c10 -5 15 -18 14 -40 -1 -29 1 -33 19 -28 12 3 40 6 64 6
61 0 52 20 -10 22 l-53 1 60 7 60 7 -57 1 c-60 2 -79 18 -30 25 15 2 2 4 -28
5 -30 0 -48 -2 -39 -6z"
          />
          <path d="M8320 2470 c0 -5 17 -10 38 -9 33 1 34 2 12 9 -36 11 -50 11 -50 0z" />
          <path
            d="M5025 2449 c-28 -16 -75 -69 -77 -88 -4 -38 -6 -47 -13 -64 -4 -11
-3 -23 4 -30 8 -8 11 -4 11 15 0 15 5 30 10 33 6 3 10 11 10 16 0 6 -4 7 -10
4 -5 -3 -10 -2 -10 3 0 6 7 12 15 16 10 4 15 -1 15 -15 0 -11 5 -17 10 -14 6
3 10 15 10 26 0 10 5 19 10 19 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -5
-10 -12 0 -6 -3 -9 -6 -5 -4 3 -4 14 0 23 5 14 9 14 23 3 15 -12 16 -12 11 2
-5 13 -2 16 15 11 19 -5 20 -3 9 10 -10 13 -10 17 0 21 7 3 9 6 3 6 -5 0 -19
-4 -30 -10z"
          />
          <path
            d="M6474 2449 c-4 -7 -24 -9 -55 -6 -29 4 -51 2 -55 -5 -4 -7 2 -8 17
-3 22 7 21 5 -5 -16 -17 -13 -37 -24 -45 -26 -12 -1 -11 2 4 14 20 15 20 15 0
11 -26 -4 -32 -35 -8 -40 10 -2 30 8 46 24 24 24 31 26 57 16 17 -5 37 -7 46
-4 8 3 23 -1 32 -10 14 -15 17 -15 29 2 16 23 13 46 -7 52 -12 4 -13 3 -3 -10
13 -15 8 -28 -9 -28 -5 0 -6 5 -2 11 4 8 -1 9 -16 4 -19 -6 -22 -4 -17 9 7 18
2 21 -9 5z"
          />
          <path
            d="M2575 2440 c16 -7 12 -9 -18 -9 -51 -1 -38 -21 14 -21 32 0 39 3 39
20 0 15 -6 20 -27 19 -25 0 -26 -1 -8 -9z"
          />
          <path
            d="M3945 2442 c-21 -7 -31 -42 -11 -42 6 0 4 -5 -4 -10 -10 -7 -11 -10
-2 -10 7 0 15 7 18 15 4 10 20 15 50 15 24 0 44 5 44 10 0 6 -11 10 -24 10
-14 0 -28 5 -31 10 -7 11 -10 11 -40 2z"
          />
          <path d="M4088 2443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M4568 2443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M5128 2443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M8153 2385 c-1 -38 1 -62 4 -52 2 9 11 17 19 17 8 0 14 10 14 25 0
15 -6 25 -14 25 -8 0 -17 12 -19 28 -2 15 -4 -4 -4 -43z"
          />
          <path
            d="M5256 2432 c-15 -3 -16 -6 -5 -13 11 -7 10 -9 -4 -9 -11 0 -15 -4
-11 -12 5 -8 2 -9 -11 -4 -15 5 -16 4 -5 -9 7 -8 17 -12 24 -8 6 3 8 3 4 -2
-4 -4 -2 -17 4 -29 7 -11 12 -41 12 -66 1 -50 15 -64 32 -31 10 20 13 21 27 6
9 -9 13 -23 10 -33 -3 -9 -3 -14 1 -10 4 3 10 28 13 54 8 81 -44 177 -91 166z
m62 -57 c15 -33 16 -87 2 -65 -6 10 -10 11 -10 3 0 -23 -27 -14 -39 13 -10 22
-9 31 4 50 20 31 29 30 43 -1z"
          />
          <path
            d="M5305 2340 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M4533 2413 c-17 -14 -17 -14 1 -5 10 5 27 7 37 5 11 -3 19 -3 19 0 0
13 -41 13 -57 0z"
          />
          <path
            d="M4692 2414 c-7 -8 -10 -19 -7 -24 3 -6 1 -10 -4 -10 -6 0 -11 5 -11
10 0 6 -5 10 -12 10 -8 0 -6 -6 5 -17 16 -16 18 -15 42 7 14 13 25 27 25 32 0
13 -24 9 -38 -8z"
          />
          <path
            d="M5073 2415 c-36 -12 -53 -25 -33 -25 9 0 6 -7 -8 -20 -21 -20 -27
-47 -22 -115 1 -16 5 -33 9 -38 4 -4 5 19 3 52 -3 44 0 65 13 85 21 31 68 58
108 61 15 2 30 5 33 8 9 8 -70 2 -103 -8z"
          />
          <path d="M8460 2420 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M4493 2408 c3 -10 2 -20 -3 -23 -6 -4 -10 0 -11 7 0 7 -5 2 -10 -11
-13 -33 -6 -35 21 -6 20 21 21 27 10 38 -10 10 -12 9 -7 -5z"
          />
          <path
            d="M5694 2395 c4 -34 12 -41 19 -16 3 11 -1 25 -8 31 -11 9 -13 6 -11
-15z"
          />
          <path d="M3403 2330 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z" />
          <path d="M7711 2384 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M8390 2395 c0 -2 10 -10 23 -16 20 -11 21 -11 8 4 -13 16 -31 23 -31
12z"
          />
          <path d="M8440 2386 c7 -7 13 -7 20 0 6 6 3 10 -10 10 -13 0 -16 -4 -10 -10z" />
          <path
            d="M5879 2352 c-8 -15 -17 -29 -20 -32 -13 -10 -31 -52 -20 -46 6 4 11
2 11 -5 0 -7 8 -5 22 7 20 18 21 18 15 1 -4 -10 -7 -23 -7 -28 0 -6 -5 -7 -12
-3 -8 5 -9 2 -5 -10 4 -10 3 -15 -3 -11 -6 3 -10 1 -10 -5 0 -6 -4 -8 -10 -5
-17 10 -11 -12 7 -26 11 -10 14 -10 9 -1 -4 6 -3 12 2 12 17 0 41 75 38 117
-2 23 1 40 5 37 5 -3 9 -1 9 5 0 22 -18 19 -31 -7z"
          />
          <path
            d="M8463 2366 c-19 -9 -21 -17 -20 -71 1 -41 7 -66 20 -79 27 -31 20
-42 -9 -15 -25 23 -26 23 -15 2 14 -28 7 -45 -26 -60 -32 -15 -55 -17 -33 -3
13 9 13 10 0 10 -8 0 -26 -3 -39 -7 -23 -6 -23 -7 -5 -14 10 -4 -26 -7 -81 -7
-76 1 -89 3 -55 8 l45 7 -42 1 c-24 1 -43 7 -43 12 0 6 19 10 43 11 l42 1 -42
15 c-30 10 -43 20 -43 33 0 22 37 37 53 21 21 -21 27 -11 26 47 0 44 -2 52 -9
35 -5 -13 -16 -23 -24 -23 -8 0 -21 -3 -29 -6 -10 -3 -17 2 -20 13 -3 10 -4
-31 -4 -92 l2 -109 43 -4 c25 -2 42 1 42 7 0 7 22 11 53 11 38 0 48 -3 37 -11
-17 -11 48 -2 88 12 27 10 29 23 2 16 -12 -3 -18 -1 -14 5 3 5 16 7 29 4 14
-4 30 1 43 12 20 17 20 20 6 47 -14 26 -13 31 0 41 9 6 15 22 15 35 -1 17 -3
19 -6 7 -2 -10 -8 -18 -13 -18 -5 0 -11 -8 -13 -17 -3 -10 -5 3 -6 29 0 25 -4
54 -8 64 -4 11 -3 15 4 11 6 -4 14 -1 17 5 3 7 3 3 0 -9 -6 -26 13 -32 22 -8
10 25 25 17 18 -9 -3 -13 -1 -27 5 -30 10 -6 10 6 2 68 0 4 -7 6 -15 3 -8 -3
-16 -3 -18 1 -2 4 -13 3 -25 -2z m-66 -252 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z"
          />
          <path
            d="M2843 2363 c-15 -5 -17 -43 -3 -43 12 0 9 -188 -3 -207 -11 -17 29
-23 117 -17 115 8 129 8 151 3 15 -3 20 2 22 28 l3 32 -108 3 -107 3 1 40 c2
50 12 75 31 75 8 0 12 -3 10 -7 -6 -9 120 -16 133 -8 18 11 -2 35 -29 34 -23
-2 -24 -2 -3 -6 45 -9 20 -18 -40 -14 -45 2 -57 6 -43 12 l20 8 -20 1 c-15 2
-12 5 10 11 21 5 15 6 -23 2 -29 -3 -52 -1 -51 4 5 30 -3 51 -18 49 -14 -2
-19 -15 -22 -57 l-5 -54 -5 56 c-4 38 -10 54 -18 52z m52 -13 c3 -5 1 -10 -4
-10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m14 -87 c-17 -20 -24
-16 -26 18 -2 31 -2 31 17 14 15 -14 17 -21 9 -32z m44 30 c-7 -2 -19 -2 -25
0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-67 -93 c17 0 19 -16 2 -23 -8 -3 -6 -6
5 -6 9 -1 17 -5 17 -11 0 -6 28 -10 65 -10 51 0 65 -3 65 -15 0 -12 -15 -15
-74 -15 -79 0 -109 6 -100 21 3 5 2 9 -3 9 -4 0 -6 21 -4 48 3 26 7 37 9 25 2
-13 10 -23 18 -23z m217 -57 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2
13 -5z"
          />
          <path d="M2923 2133 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path
            d="M5916 2354 c-3 -9 -4 -20 0 -25 3 -5 1 -9 -4 -9 -6 0 -8 -10 -4 -22
l5 -22 9 23 c9 26 28 19 29 -12 1 -14 3 -16 6 -7 3 15 -22 90 -31 90 -2 0 -7
-7 -10 -16z"
          />
          <path
            d="M7220 2345 c0 -14 -4 -25 -10 -25 -5 0 -10 -10 -10 -22 0 -17 3 -20
9 -9 7 11 10 10 14 -5 2 -10 5 5 6 34 0 28 -1 52 -4 52 -3 0 -5 -11 -5 -25z"
          />
          <path d="M3423 2310 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" />
          <path
            d="M5720 2327 c-12 -19 -11 -20 2 -10 17 15 29 7 21 -13 -3 -9 0 -14 8
-12 10 2 13 -5 11 -22 -2 -19 0 -22 8 -10 8 12 10 13 10 1 0 -8 3 -12 6 -9 6
7 -10 42 -36 75 l-16 21 -14 -21z"
          />
          <path
            d="M6357 2343 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"
          />
          <path
            d="M6380 2320 c0 -6 6 -10 13 -9 26 3 35 -2 40 -22 5 -18 2 -20 -17 -17
-13 3 -23 0 -23 -8 0 -8 9 -9 26 -5 14 3 35 5 46 5 11 -1 34 -3 50 -4 17 -1
23 -4 15 -7 -8 -3 -21 -12 -27 -21 -12 -14 -13 -13 -13 5 0 16 -5 20 -20 16
-19 -5 -18 -6 6 -26 20 -15 28 -17 34 -7 4 7 12 10 18 6 6 -3 13 0 16 6 3 7 3
0 0 -17 -4 -21 -3 -26 4 -16 5 7 14 11 20 7 13 -8 3 32 -15 61 -20 31 -173 78
-173 53z"
          />
          <path
            d="M2478 2298 c0 -13 -1 -30 0 -38 1 -9 -8 -22 -20 -29 -11 -7 -17 -8
-13 -2 3 7 -2 11 -14 11 -14 0 -21 8 -24 28 -2 15 -5 5 -6 -23 l-1 -51 35 4
c29 4 36 0 44 -19 7 -18 10 -4 10 59 1 45 -1 82 -4 82 -3 0 -6 -10 -7 -22z"
          />
          <path d="M3063 2313 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
          <path
            d="M6319 2290 c18 -17 41 -30 49 -30 8 0 12 3 8 7 -3 4 3 12 15 19 21
11 20 12 -19 19 -23 3 -46 4 -52 0 -5 -3 -10 -1 -10 4 0 6 -6 11 -12 11 -7 0
2 -14 21 -30z m48 4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
          />
          <path d="M7183 2280 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
          <path
            d="M7729 2263 c-1 -48 -3 -53 -9 -28 -7 27 -8 26 -9 -15 0 -30 2 -40 8
-31 7 11 10 10 14 -5 2 -10 5 16 6 59 0 42 -1 77 -4 77 -3 0 -6 -26 -6 -57z"
          />
          <path d="M4372 2280 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
          <path d="M4971 2294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M4432 2285 c-10 -17 -13 -18 -22 -5 -8 13 -10 13 -10 -2 0 -11 7 -18
18 -18 11 0 24 -12 31 -26 18 -40 23 -24 8 27 -12 40 -14 42 -25 24z"
          />
          <path
            d="M8515 2255 c-14 -69 -15 -80 -6 -65 12 19 25 90 17 90 -3 0 -8 -11
-11 -25z"
          />
          <path d="M5621 2254 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M5820 2256 c0 -2 7 -9 15 -16 9 -7 15 -8 15 -2 0 5 -7 12 -15 16 -8
3 -15 4 -15 2z"
          />
          <path d="M5951 2244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M4386 2234 c-8 -22 -4 -25 11 -9 7 8 9 16 4 19 -5 3 -12 -1 -15 -10z" />
          <path d="M4945 2239 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M5741 2216 c13 -22 25 -34 27 -28 2 6 -8 24 -23 39 l-26 28 22 -39z" />
          <path d="M3440 2213 c0 -18 2 -33 4 -33 9 0 13 39 5 51 -6 10 -9 4 -9 -18z" />
          <path d="M5306 2223 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
          <path
            d="M5790 2216 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3
-10 -1 -10 -9z"
          />
          <path d="M3401 2204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M5250 2208 c0 -9 6 -19 13 -21 9 -4 9 -8 -1 -15 -11 -7 -10 -11 4
-16 9 -3 14 -9 11 -13 -9 -8 -38 17 -31 28 11 19 -8 30 -25 15 -9 -9 -35 -20
-57 -25 l-39 -9 48 -1 c30 -1 46 3 42 9 -3 6 -1 10 4 10 6 0 11 -6 11 -14 0
-8 6 -16 13 -19 6 -3 -26 -3 -73 -2 -47 2 -69 1 -50 -2 l35 -6 -30 -7 c-28 -7
-26 -8 15 -10 l45 -3 -35 -7 -35 -7 43 -2 c23 0 42 3 42 9 0 5 7 6 17 3 12 -5
14 -3 8 7 -5 9 -4 11 4 6 14 -9 63 25 86 61 18 28 18 28 -2 11 -25 -23 -37
-23 -29 -1 4 10 4 14 0 10 -4 -4 -13 1 -20 11 -12 16 -13 16 -14 0z m-47 -85
c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"
          />
          <path
            d="M7161 2198 c-2 -37 8 -58 28 -58 15 1 15 2 -1 13 -9 7 -18 26 -21 42
-4 29 -4 29 -6 3z"
          />
          <path
            d="M4413 2168 c29 -38 52 -53 76 -49 7 1 10 -2 7 -8 -8 -12 51 -25 85
-18 17 3 13 5 -13 6 -43 1 -58 16 -27 26 16 5 18 9 9 15 -8 5 8 9 39 11 50 4
69 -4 34 -15 -15 -4 -15 -5 2 -4 43 1 49 -3 20 -17 -20 -9 -24 -14 -12 -14 22
-1 69 22 85 42 10 12 9 16 -2 20 -10 4 -13 1 -10 -7 8 -21 -27 -29 -45 -10
-15 15 -14 16 9 9 17 -4 21 -3 12 3 -11 7 -10 11 4 16 12 5 14 10 7 17 -13 13
-36 3 -28 -11 3 -5 -3 -9 -12 -10 -103 -7 -144 -8 -139 -3 8 9 -27 32 -38 25
-5 -3 -1 -9 10 -14 14 -6 10 -7 -16 -6 -19 1 -46 9 -60 18 -25 15 -25 15 3
-22z m52 -18 c4 -6 11 -8 16 -5 5 4 17 1 26 -5 15 -8 11 -10 -16 -6 -32 5 -69
26 -44 26 7 0 15 -5 18 -10z"
          />
          <path
            d="M5040 2191 c0 -3 12 -14 28 -23 19 -12 22 -18 10 -18 -9 0 -20 5 -24
11 -5 8 -10 6 -16 -5 -5 -9 -14 -16 -21 -16 -7 0 -6 4 3 10 12 7 10 9 -8 7
-34 -2 -26 -19 13 -26 6 -2 17 -8 25 -15 8 -7 24 -16 34 -20 15 -5 17 -4 8 7
-7 8 -9 17 -5 20 3 4 -3 7 -15 7 -11 0 -24 5 -28 11 -4 7 0 9 13 5 11 -4 30
-3 41 1 19 7 18 10 -19 30 -21 12 -39 18 -39 14z"
          />
          <path
            d="M8398 2186 c-24 -17 -23 -26 3 -26 13 0 18 4 13 12 -5 8 -2 9 10 5
11 -5 16 -3 14 5 -6 17 -21 19 -40 4z"
          />
          <path
            d="M6295 2181 c4 -3 21 -12 38 -18 l32 -12 -33 3 c-22 3 -32 1 -29 -7 2
-7 18 -11 38 -9 59 6 60 17 3 33 -30 9 -52 14 -49 10z"
          />
          <path
            d="M5784 2160 c1 -17 36 -27 36 -11 0 6 -6 8 -14 5 -8 -3 -16 0 -19 8
-3 9 -4 8 -3 -2z"
          />
          <path
            d="M6550 2169 c0 -5 -5 -7 -12 -3 -7 4 -8 3 -4 -4 9 -14 -9 -16 -32 -3
-9 5 -35 5 -57 1 l-40 -8 46 1 c49 1 69 -7 68 -26 0 -9 -2 -9 -6 1 -2 6 -9 12
-15 12 -6 0 -8 -6 -5 -13 4 -10 -2 -13 -21 -9 -24 5 -25 6 -7 13 14 5 6 8 -25
7 -37 0 -41 -1 -20 -8 21 -7 22 -8 5 -10 -17 -2 -17 -3 5 -11 19 -7 16 -8 -17
-4 -23 3 -44 1 -47 -3 -2 -4 19 -9 47 -10 57 -3 127 22 127 45 0 7 4 13 9 13
5 0 11 7 15 15 3 8 1 15 -4 15 -6 0 -10 -5 -10 -11z"
          />
          <path
            d="M3957 2158 c2 -5 47 -8 99 -8 61 0 93 -4 89 -10 -3 -5 -1 -10 4 -10
6 0 11 6 11 14 0 12 -22 15 -104 18 -57 2 -102 0 -99 -4z"
          />
          <path
            d="M3568 2151 c47 -9 44 -25 -5 -29 -24 -2 -43 -7 -43 -11 0 -13 53 -21
91 -15 29 5 34 10 35 35 1 29 1 29 -55 28 -45 -1 -50 -3 -23 -8z"
          />
          <path d="M8318 2153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M6270 2141 c0 -13 22 -29 53 -36 16 -4 27 -3 27 3 0 6 6 13 13 15 6
2 0 3 -14 1 -34 -4 -70 6 -63 17 3 5 0 9 -5 9 -6 0 -11 -4 -11 -9z"
          />
          <path
            d="M3370 2123 c0 -20 9 -26 40 -25 23 0 94 13 98 17 3 3 -18 5 -47 5
-32 0 -50 4 -46 10 3 6 2 10 -4 10 -5 0 -12 -6 -14 -12 -4 -10 -8 -9 -16 2 -9
12 -11 11 -11 -7z"
          />
          <path
            d="M5590 2129 c0 -5 5 -7 10 -4 6 3 10 1 10 -4 0 -6 -5 -11 -12 -11 -9
0 -9 -3 -1 -11 6 -6 16 -8 22 -5 16 10 13 33 -5 40 -21 8 -24 8 -24 -5z"
          />
          <path d="M5950 2136 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z" />
          <path
            d="M7188 2133 c-21 -5 -31 -30 -14 -36 14 -6 94 7 103 17 4 3 -2 6 -13
7 -18 0 -18 1 1 9 15 7 11 8 -20 8 -22 0 -47 -2 -57 -5z"
          />
          <path
            d="M7745 2115 c0 -27 0 -27 33 -19 25 7 30 34 6 34 -8 0 -12 -4 -9 -10
10 -16 -7 -11 -19 5 -9 13 -11 11 -11 -10z"
          />
          <path
            d="M6015 2120 c3 -5 1 -10 -4 -10 -6 0 -11 -5 -11 -11 0 -8 5 -8 15 1
17 14 20 30 4 30 -5 0 -7 -4 -4 -10z"
          />
          <path
            d="M2400 2113 c0 -5 20 -8 45 -8 25 0 45 3 45 7 0 5 -20 8 -45 8 -25 0
-45 -3 -45 -7z"
          />
          <path d="M4553 2113 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
          <path d="M5950 2111 c0 -5 7 -12 16 -15 24 -9 27 -7 10 9 -17 17 -26 19 -26 6z" />
          <path
            d="M7710 2110 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path d="M4693 1854 c-3 -8 -1 -20 4 -25 14 -14 43 0 43 22 0 24 -38 26 -47 3z" />
          <path
            d="M4799 1863 c-11 -3 -21 -29 -33 -86 -31 -151 -31 -139 -5 -135 20 3
25 14 45 108 12 58 20 108 16 111 -4 3 -14 4 -23 2z"
          />
          <path
            d="M4881 1861 c-7 -5 -21 -48 -32 -97 -23 -114 -23 -124 0 -124 15 0 22
11 30 53 6 28 16 76 23 105 12 55 4 78 -21 63z"
          />
          <path
            d="M6023 1854 c-6 -17 14 -36 32 -31 6 2 11 13 13 25 3 17 -2 22 -18 22
-11 0 -23 -7 -27 -16z"
          />
          <path
            d="M7708 1863 c-10 -3 -18 -8 -18 -11 0 -4 -9 -49 -20 -101 -25 -116
-25 -113 2 -109 18 2 24 12 31 48 11 56 22 70 55 70 25 0 25 -1 19 -61 -7 -58
-6 -60 16 -57 19 3 23 12 31 62 12 75 3 91 -54 91 -42 0 -42 0 -37 32 6 35 1
42 -25 36z"
          />
          <path
            d="M2460 1830 c0 -16 7 -20 30 -20 35 0 36 -7 15 -95 -19 -77 -19 -75 9
-75 21 0 25 6 31 43 4 23 11 61 17 85 10 39 13 42 44 42 27 0 34 4 34 20 0 19
-7 20 -90 20 -83 0 -90 -1 -90 -20z"
          />
          <path
            d="M3142 1786 c-7 -35 -12 -74 -12 -88 0 -47 58 -77 114 -58 50 16 68
42 87 130 l17 80 -23 0 c-20 0 -24 -8 -36 -67 -18 -93 -65 -139 -99 -98 -12
15 -9 86 6 143 5 18 2 22 -18 22 -22 0 -26 -6 -36 -64z"
          />
          <path
            d="M3775 1838 c-2 -7 -11 -49 -20 -93 -10 -44 -20 -85 -22 -92 -3 -9 4
-13 20 -13 20 0 27 6 32 30 6 28 9 30 56 30 40 0 55 5 74 25 33 32 34 87 3
109 -28 20 -137 22 -143 4z m115 -32 c0 -2 3 -11 6 -19 8 -23 -24 -47 -63 -47
-28 0 -34 3 -29 16 3 9 6 24 6 35 0 16 7 19 40 19 22 0 40 -2 40 -4z"
          />
          <path
            d="M4456 1763 c-10 -49 -19 -96 -22 -105 -5 -16 3 -18 73 -18 91 0 123
15 123 59 0 15 -5 32 -11 38 -9 9 -8 16 5 28 20 21 21 49 0 69 -11 11 -35 16
-83 16 l-68 0 -17 -87z m134 34 c0 -22 -23 -37 -58 -37 -27 0 -33 3 -28 16 3
9 6 20 6 25 0 5 18 9 40 9 26 0 40 -4 40 -13z m-26 -73 c9 -3 16 -14 16 -24 0
-21 -19 -30 -61 -30 -24 0 -29 4 -29 23 0 13 3 27 7 30 8 9 46 9 67 1z"
          />
          <path
            d="M5278 1745 l-67 -105 29 0 c20 0 31 6 35 20 5 17 15 20 60 20 44 0
53 -3 58 -20 6 -22 47 -29 47 -7 0 6 -11 53 -23 102 -21 81 -26 90 -48 93 -21
2 -33 -12 -91 -103z m96 3 c6 -26 4 -28 -24 -28 -35 0 -35 1 -14 42 17 33 28
29 38 -14z"
          />
          <path
            d="M6787 1745 c-63 -100 -65 -105 -42 -105 14 0 30 9 37 20 10 16 24 20
65 20 46 0 53 -3 53 -20 0 -15 7 -20 25 -20 30 0 30 2 2 115 -21 81 -26 90
-48 93 -22 3 -33 -10 -92 -103z m93 3 c0 -23 -4 -28 -25 -28 -30 0 -30 0 -8
45 18 38 33 31 33 -17z"
          />
          <path
            d="M5900 1825 c0 -8 -9 -19 -20 -25 -21 -11 -28 -40 -9 -40 7 0 9 -16 4
-49 -6 -45 -5 -51 19 -66 27 -18 66 -12 66 10 0 7 -10 15 -22 17 -23 3 -25 10
-13 66 3 13 13 22 24 22 10 0 22 7 25 16 9 23 8 24 -14 24 -13 0 -20 7 -20 20
0 13 -7 20 -20 20 -11 0 -20 -7 -20 -15z"
          />
          <path
            d="M2663 1790 c-28 -11 -43 -40 -43 -83 0 -57 54 -88 112 -64 45 19 60
40 60 84 0 61 -60 91 -129 63z m85 -58 c4 -28 -23 -62 -50 -62 -26 0 -43 41
-28 69 16 32 74 26 78 -7z"
          />
          <path
            d="M2821 1692 c-25 -129 -25 -122 -1 -122 14 0 22 11 30 41 9 33 14 39
28 33 60 -27 122 14 122 81 0 59 -20 74 -96 74 l-62 -1 -21 -106z m134 48 c9
-29 -21 -72 -47 -68 -55 8 -45 88 11 88 21 0 32 -6 36 -20z"
          />
          <path
            d="M3361 1691 c-25 -125 -24 -120 -8 -117 23 3 34 16 40 46 6 28 8 29
31 19 30 -14 79 3 101 35 19 27 19 76 0 103 -13 19 -24 22 -79 21 l-64 -1 -21
-106z m134 49 c13 -41 -39 -86 -70 -60 -18 15 -19 34 -5 61 15 26 66 26 75 -1z"
          />
          <path
            d="M3987 1779 c-47 -36 -43 -120 7 -139 13 -5 45 -6 72 -2 l48 7 13 60
c20 96 22 92 -51 93 -50 1 -70 -3 -89 -19z m86 -30 c19 -26 10 -58 -19 -71
-48 -22 -76 45 -32 76 29 21 34 20 51 -5z"
          />
          <path
            d="M4170 1793 c0 -4 9 -41 19 -81 14 -57 15 -76 6 -89 -7 -9 -19 -14
-28 -10 -22 8 -46 -21 -26 -34 43 -27 87 11 161 139 46 80 47 82 23 82 -18 0
-30 -11 -51 -50 -15 -27 -30 -50 -35 -50 -4 0 -11 21 -15 48 -7 38 -13 48 -32
50 -12 2 -22 0 -22 -5z"
          />
          <path
            d="M4672 1735 c-7 -35 -15 -71 -18 -80 -5 -11 0 -15 19 -15 22 0 26 6
36 63 7 34 14 70 17 80 4 13 -1 17 -19 17 -21 0 -25 -6 -35 -65z"
          />
          <path
            d="M4941 1781 c-12 -12 -21 -25 -21 -31 0 -17 39 -50 60 -50 12 0 20 -7
20 -16 0 -14 -7 -16 -44 -11 -33 5 -45 3 -50 -8 -7 -20 63 -39 96 -26 60 23
59 83 -2 96 -43 9 -32 31 14 28 31 -2 37 1 34 15 -5 27 -81 29 -107 3z"
          />
          <path
            d="M5478 1719 c-15 -79 -15 -79 7 -79 17 0 23 10 35 58 14 53 17 57 45
57 27 0 30 -3 30 -30 -1 -16 -4 -42 -8 -57 -7 -25 -5 -28 16 -28 21 0 26 7 36
57 9 47 9 60 -4 79 -13 20 -23 23 -78 23 l-64 -1 -15 -79z"
          />
          <path
            d="M5684 1778 c17 -64 28 -139 22 -154 -4 -11 -13 -14 -30 -10 -27 7
-46 -22 -24 -36 39 -24 74 2 132 97 25 42 53 87 62 100 16 24 16 25 -9 25 -21
0 -32 -10 -54 -50 -27 -49 -43 -62 -43 -37 0 6 -5 29 -11 50 -7 27 -15 37 -31
37 -16 0 -19 -4 -14 -22z"
          />
          <path
            d="M6015 1788 c-3 -7 -11 -43 -19 -80 -14 -68 -14 -68 9 -68 19 0 24 8
35 63 6 34 14 70 17 80 3 12 -2 17 -17 17 -11 0 -23 -6 -25 -12z"
          />
          <path
            d="M6090 1742 c-7 -31 -14 -67 -17 -79 -4 -19 -1 -23 20 -23 22 0 25 5
31 49 7 52 24 75 53 69 15 -3 18 -12 15 -61 -3 -51 -1 -57 17 -57 15 0 21 9
26 38 11 64 22 82 51 82 27 0 27 0 21 -61 -7 -58 -6 -60 16 -57 19 3 23 12 31
62 12 76 3 92 -55 89 -58 -3 -54 -3 -131 2 l-67 4 -11 -57z"
          />
          <path
            d="M6419 1771 c-67 -68 -7 -162 85 -131 49 16 38 39 -17 37 -30 -2 -42
2 -44 13 -3 13 8 15 54 15 56 0 58 1 61 27 8 67 -85 93 -139 39z m91 -16 c7
-8 11 -15 9 -16 -20 -6 -79 -6 -79 0 0 29 50 40 70 16z"
          />
          <path
            d="M7005 1786 c-2 -6 -10 -41 -18 -78 l-15 -68 23 0 c18 0 25 7 30 33
13 64 26 87 52 87 31 0 38 -22 26 -76 -10 -42 -9 -44 13 -44 19 0 24 8 33 50
14 66 14 76 -4 94 -18 18 -135 20 -140 2z"
          />
          <path
            d="M7190 1798 c1 -2 9 -38 19 -80 20 -85 15 -104 -28 -110 -32 -4 -38
-24 -11 -33 43 -14 73 12 135 115 33 55 62 100 66 100 3 0 11 -34 18 -75 11
-69 14 -75 37 -75 19 0 29 10 46 45 12 25 25 45 29 45 4 0 10 -20 13 -45 6
-39 11 -45 31 -45 19 0 31 15 64 75 23 41 41 77 41 80 0 3 -9 5 -20 5 -14 0
-28 -16 -46 -52 -23 -46 -28 -50 -35 -33 -4 11 -8 35 -8 53 -1 26 -5 32 -23
32 -17 0 -31 -14 -53 -53 -27 -49 -29 -51 -36 -27 -4 14 -7 38 -8 53 -1 27 -3
28 -48 25 -46 -3 -49 -5 -80 -56 l-32 -54 -10 39 c-6 21 -11 46 -11 56 0 11
-8 17 -25 17 -14 0 -25 -1 -25 -2z"
          />
          <path
            d="M7904 1788 c-24 -11 -44 -48 -44 -79 0 -56 55 -89 115 -69 48 16 39
35 -15 35 -56 0 -68 25 -13 26 76 2 78 3 81 31 6 54 -63 86 -124 56z m76 -33
c7 -8 11 -15 9 -16 -69 -13 -101 -3 -61 20 24 14 38 13 52 -4z"
          />
          <path
            d="M8058 1719 l-15 -79 23 0 c19 0 24 7 30 38 8 49 30 82 54 82 13 0 20
7 20 18 0 15 -9 19 -48 20 l-48 1 -16 -80z"
          />
          <path
            d="M8217 1780 c-28 -22 -42 -68 -32 -101 11 -32 69 -53 111 -39 39 13
41 36 3 33 -34 -3 -69 6 -69 17 0 6 17 10 38 10 64 0 82 9 82 41 0 55 -82 79
-133 39z m83 -20 c18 -11 7 -23 -27 -26 -37 -4 -50 6 -28 23 22 15 34 16 55 3z"
          />
          <path
            d="M1615 1730 c-231 -4 -270 -7 -270 -20 0 -13 30 -15 205 -16 154 -1
183 1 115 6 -49 4 -130 5 -180 3 -51 -3 -101 -1 -115 5 -18 8 92 10 380 10
223 -1 388 -3 368 -5 -53 -6 -48 -25 5 -21 32 2 42 7 42 21 0 16 -14 18 -140
20 -77 1 -261 0 -410 -3z"
          />
          <path
            d="M8633 1715 c2 -21 47 -36 47 -16 0 6 -9 11 -19 11 -11 0 -22 6 -25
13 -3 6 -5 3 -3 -8z"
          />
          <path d="M8673 1723 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
          <path
            d="M8895 1723 c303 -7 563 -7 558 0 -2 4 -156 6 -341 5 -185 -1 -283 -4
-217 -5z"
          />
          <path
            d="M1865 1700 c-4 -6 27 -10 87 -9 61 0 86 3 73 9 -28 12 -153 12 -160
0z"
          />
          <path
            d="M8755 1700 c3 -6 50 -10 106 -10 59 0 99 4 99 10 0 6 -42 10 -106 10
-67 0 -103 -4 -99 -10z"
          />
          <path
            d="M9055 1700 c-54 -4 -1 -6 133 -6 122 -1 222 2 222 5 0 8 -230 8 -355
1z"
          />
          <path d="M1778 1693 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
          <path
            d="M3560 1674 c-11 -12 -10 -18 3 -32 16 -15 18 -15 33 0 19 18 12 48
-9 48 -8 0 -20 -7 -27 -16z"
          />
          <path
            d="M5070 1674 c-11 -12 -10 -18 3 -32 16 -15 18 -15 33 0 19 18 12 48
-9 48 -8 0 -20 -7 -27 -16z"
          />
          <path
            d="M6580 1675 c-6 -8 -9 -19 -5 -24 3 -6 1 -20 -5 -32 -24 -43 17 -34
43 10 27 45 -1 84 -33 46z"
          />
          <path
            d="M8370 1674 c-11 -12 -10 -18 3 -32 16 -15 18 -15 33 0 19 18 12 48
-9 48 -8 0 -20 -7 -27 -16z"
          />
          <path
            d="M4584 1266 c-158 -51 -228 -245 -137 -382 35 -54 81 -90 96 -75 8 8
2 21 -25 49 -20 20 -43 51 -52 68 -72 145 36 313 201 314 47 0 74 12 59 27
-12 13 -103 12 -142 -1z"
          />
          <path
            d="M5856 1264 c-9 -8 -16 -23 -16 -32 -1 -9 -1 -89 0 -177 0 -137 3
-162 17 -172 11 -9 53 -13 120 -13 57 0 103 -3 103 -6 0 -3 -15 -22 -34 -42
-37 -39 -38 -63 -3 -39 12 8 21 23 19 32 -2 9 1 14 7 11 5 -3 18 5 29 19 27
34 80 34 112 0 12 -13 27 -22 31 -19 5 3 11 -7 15 -21 3 -14 13 -25 23 -25 9
0 12 3 6 8 -12 8 -55 69 -55 77 0 3 47 5 104 5 140 0 136 -6 136 207 0 150 -2
165 -20 183 -19 19 -33 20 -299 20 -241 0 -282 -2 -295 -16z m569 -189 l0
-160 -275 0 -275 0 -3 150 c-1 82 0 155 2 162 4 11 61 13 278 11 l273 -3 0
-160z m-339 -233 c-17 -16 -18 -16 -5 5 7 12 15 20 18 17 3 -2 -3 -12 -13 -22z"
          />
          <path
            d="M5990 1135 c0 -9 9 -15 25 -15 24 0 25 -2 25 -65 0 -58 2 -65 20 -65
18 0 20 7 20 65 0 63 1 65 25 65 16 0 25 6 25 15 0 12 -14 15 -70 15 -56 0
-70 -3 -70 -15z"
          />
          <path
            d="M6151 1123 c6 -16 20 -52 31 -80 15 -42 24 -53 41 -53 18 0 27 13 50
73 32 85 32 87 9 87 -14 0 -23 -15 -37 -57 l-18 -58 -15 35 c-8 19 -18 45 -23
58 -5 12 -17 22 -29 22 -17 0 -18 -3 -9 -27z"
          />
          <path
            d="M8526 1258 c-13 -19 -16 -59 -16 -239 l0 -218 26 -20 c23 -18 41 -21
139 -21 61 0 114 3 118 6 3 3 3 12 0 20 -4 11 -31 14 -119 14 -110 0 -114 1
-119 23 -3 12 -4 112 -3 222 l3 200 118 3 117 3 0 -49 c0 -59 12 -72 67 -72
41 0 43 -1 43 -31 0 -24 4 -30 18 -27 12 2 17 14 18 43 2 36 -4 46 -59 103
l-61 62 -138 0 c-130 0 -138 -1 -152 -22z m344 -80 c0 -5 -11 -8 -25 -8 -20 0
-25 5 -25 25 0 26 0 26 25 8 13 -10 25 -21 25 -25z"
          />
          <path
            d="M1867 1252 c-15 -16 -17 -48 -17 -235 0 -183 2 -218 16 -231 12 -13
40 -16 137 -16 67 0 129 5 137 10 11 7 16 37 21 117 3 59 8 117 12 128 5 14 4
13 -4 -2 -7 -13 -18 -23 -26 -23 -10 0 -13 -21 -13 -88 0 -55 -4 -92 -12 -100
-8 -8 -48 -12 -115 -12 -92 0 -103 2 -113 20 -7 12 -9 91 -8 212 l3 193 120 0
120 0 3 -67 c2 -52 6 -68 17 -68 12 0 15 16 15 74 0 101 -7 106 -161 106 -100
0 -118 -3 -132 -18z"
          />
          <path
            d="M3232 1262 c-44 -13 -111 -76 -137 -129 -24 -51 -37 -140 -14 -100 5
9 7 22 4 27 -3 6 -2 10 3 10 11 0 27 47 23 69 -1 7 2 10 8 6 6 -3 11 -1 11 5
0 7 8 9 19 5 11 -3 22 -1 26 4 3 6 0 8 -8 5 -8 -3 -18 0 -22 6 -11 17 25 50
54 50 24 1 78 30 55 30 -5 0 -2 5 6 10 17 11 7 11 -28 2z"
          />
          <path
            d="M3368 1263 c-24 -6 -23 -26 2 -48 12 -11 20 -13 20 -6 0 6 -7 14 -15
17 -23 9 -18 23 7 16 16 -4 19 -2 13 9 -4 8 2 4 14 -8 18 -19 51 -23 51 -6 0
4 -67 34 -72 32 -2 -1 -11 -3 -20 -6z"
          />
          <path
            d="M7465 1251 c4 -7 1 -18 -6 -23 -11 -8 -10 -9 3 -4 14 4 22 -4 33 -32
9 -20 21 -42 28 -47 7 -6 22 -28 34 -50 12 -22 27 -39 33 -37 6 1 9 -2 6 -7
-7 -11 13 -72 30 -91 12 -12 14 -10 14 15 0 17 -5 37 -11 45 -8 11 -9 8 -5
-15 5 -22 4 -26 -4 -15 -5 8 -10 25 -10 37 0 32 -11 54 -23 46 -6 -4 -8 0 -4
10 4 12 2 14 -10 10 -13 -5 -15 -2 -10 11 4 10 3 15 -3 11 -6 -3 -10 2 -10 12
-1 23 -25 55 -35 45 -5 -4 -6 0 -3 8 3 9 -7 31 -24 50 -16 19 -26 29 -23 21z"
          />
          <path
            d="M3275 1236 c-35 -47 -62 -93 -62 -106 0 -8 -3 -25 -7 -37 -5 -17 -4
-22 6 -18 8 3 13 21 13 43 0 25 4 36 13 34 8 -1 11 2 8 6 -3 5 6 22 19 36 14
15 25 34 25 42 0 17 -2 18 -15 0z"
          />
          <path
            d="M4771 1236 c-8 -10 -1 -20 30 -46 78 -62 103 -174 59 -264 -40 -84
-134 -136 -219 -122 -28 4 -42 2 -51 -9 -20 -24 -4 -30 73 -29 53 0 83 6 112
21 162 84 195 290 68 417 -39 39 -59 48 -72 32z"
          />
          <path
            d="M7409 1203 c-18 -25 -26 -42 -19 -38 10 6 12 3 7 -11 -7 -18 -6 -18
8 1 8 11 20 26 26 34 11 12 20 61 12 61 -1 0 -16 -21 -34 -47z"
          />
          <path d="M3312 1216 c1 -15 8 -26 14 -26 7 0 10 8 7 20 -8 31 -23 35 -21 6z" />
          <path
            d="M1960 1200 c0 -5 20 -10 45 -10 25 0 45 5 45 10 0 6 -20 10 -45 10
-25 0 -45 -4 -45 -10z"
          />
          <path
            d="M3480 1199 c-12 -9 -12 -10 3 -5 11 3 17 0 17 -10 0 -8 -4 -13 -9
-10 -4 3 -19 -6 -31 -19 -23 -25 -47 -35 -35 -15 3 6 2 10 -3 10 -6 0 -13 -7
-16 -16 -9 -24 -7 -31 4 -14 8 12 10 11 10 -7 0 -13 5 -23 11 -23 6 0 9 7 6
15 -6 14 40 55 62 55 6 0 11 6 11 13 0 8 4 7 10 -3 5 -8 10 -10 10 -4 0 21
-34 44 -50 33z"
          />
          <path
            d="M4695 1187 c-11 -14 -48 -59 -83 -102 -34 -42 -60 -81 -57 -86 4 -5
24 -9 46 -9 21 0 39 -3 39 -7 0 -5 -9 -37 -20 -72 -11 -35 -18 -66 -16 -68 9
-9 176 179 176 198 0 5 -19 9 -43 9 -24 0 -46 2 -49 6 -3 3 3 34 14 70 23 76
20 95 -7 61z"
          />
          <path d="M2693 1120 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z" />
          <path
            d="M3940 905 c0 -190 4 -295 10 -295 6 0 10 105 10 295 0 190 -4 295
-10 295 -6 0 -10 -105 -10 -295z"
          />
          <path
            d="M5400 905 c1 -178 5 -295 11 -295 5 0 9 116 9 295 0 195 -3 295 -10
295 -7 0 -10 -100 -10 -295z"
          />
          <path
            d="M6900 905 c0 -177 4 -295 9 -295 6 0 10 118 10 295 -1 172 -4 295
-10 295 -5 0 -9 -123 -9 -295z"
          />
          <path
            d="M8070 905 c0 -190 4 -295 10 -295 6 0 10 105 10 295 0 190 -4 295
-10 295 -6 0 -10 -105 -10 -295z"
          />
          <path
            d="M3314 1168 c1 -7 8 -22 15 -33 11 -17 12 -17 7 -2 -3 10 -6 25 -6 33
0 8 -4 14 -9 14 -5 0 -8 -6 -7 -12z"
          />
          <path
            d="M8600 1155 c0 -12 14 -15 70 -15 56 0 70 3 70 15 0 12 -14 15 -70 15
-56 0 -70 -3 -70 -15z"
          />
          <path d="M2220 1146 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z" />
          <path
            d="M3275 1120 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M3354 1118 c-3 -4 4 -8 15 -8 12 0 21 4 21 8 0 5 -7 9 -15 9 -9 0
-18 -4 -21 -9z"
          />
          <path
            d="M2277 1086 c20 -38 21 -115 2 -127 -10 -6 -10 -9 -2 -9 21 0 46 59
37 89 -4 14 -6 30 -5 34 1 5 -4 5 -10 1 -9 -5 -10 -2 -6 10 5 11 3 15 -5 10
-7 -5 -9 -2 -6 8 4 8 0 15 -7 15 -11 0 -11 -6 2 -31z"
          />
          <path
            d="M7331 1091 c-13 -18 -18 -36 -14 -46 6 -17 7 -17 19 0 7 9 10 24 7
33 -4 8 -2 13 3 9 5 -3 10 3 10 14 0 25 -1 24 -25 -10z"
          />
          <path d="M3318 1103 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3547 1104 c-12 -12 -8 -24 8 -24 8 0 15 -7 15 -16 0 -8 -4 -12 -10
-9 -5 3 -10 1 -10 -5 0 -16 24 -6 28 11 3 18 -21 53 -31 43z"
          />
          <path
            d="M2195 1091 c-3 -5 2 -11 10 -15 8 -3 17 -1 20 3 3 5 -2 11 -10 15 -8
3 -17 1 -20 -3z"
          />
          <path
            d="M8600 1075 c0 -13 15 -15 108 -13 63 2 107 7 107 13 0 6 -44 11 -107
13 -93 2 -108 0 -108 -13z"
          />
          <path
            d="M2225 1060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M3331 1054 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M8892 1042 c3 -24 -4 -41 -19 -45 -14 -4 -13 -5 4 -6 12 0 24 -10 28
-21 9 -30 25 -24 25 9 0 36 11 66 19 53 3 -5 17 -13 31 -17 23 -7 24 -6 9 10
-15 16 -99 30 -97 17z m24 -26 c0 -14 -5 -21 -9 -17 -4 4 -5 15 -1 24 9 24 12
21 10 -7z"
          />
          <path
            d="M3425 1030 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"
          />
          <path
            d="M3115 1020 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M3140 1019 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M3245 1020 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M3270 1019 c0 -5 9 -9 20 -9 11 0 20 -4 20 -10 0 -5 4 -10 9 -10 5 0
7 8 4 19 -5 19 -53 28 -53 10z"
          />
          <path d="M3467 1018 c-16 -10 53 -9 78 2 15 6 9 8 -23 7 -23 -1 -48 -5 -55 -9z" />
          <path d="M2235 1009 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path d="M3428 1003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M8605 1000 c-13 -22 12 -31 76 -28 49 2 64 7 64 18 0 12 -15 16 -67
18 -41 2 -69 -1 -73 -8z"
          />
          <path
            d="M8940 998 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4
-15 -9z"
          />
          <path
            d="M7282 974 c-13 -26 -6 -74 9 -74 5 0 9 23 9 50 0 28 -2 50 -3 50 -2
0 -9 -12 -15 -26z"
          />
          <path
            d="M2215 970 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"
          />
          <path
            d="M3546 965 c-3 -8 -1 -15 5 -15 6 0 8 -9 4 -21 -5 -15 -4 -19 4 -14 7
4 11 14 9 23 -1 10 1 23 5 30 5 7 3 12 -6 12 -8 0 -17 -7 -21 -15z"
          />
          <path d="M8841 964 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M9027 953 c-3 -15 -1 -31 5 -34 6 -4 2 -15 -12 -29 -22 -22 -22 -22
-1 -15 16 5 21 2 22 -12 0 -14 2 -13 10 5 5 14 5 39 0 63 -12 52 -17 57 -24
22z"
          />
          <path
            d="M3076 954 c-4 -9 3 -31 14 -48 11 -17 20 -25 20 -18 0 7 4 11 9 8 4
-3 -1 12 -11 34 -23 45 -24 46 -32 24z"
          />
          <path
            d="M3207 942 c1 -8 3 -16 3 -18 0 -3 5 -2 10 1 6 3 10 14 10 23 0 13 -2
14 -9 3 -5 -7 -11 -9 -13 -5 -3 5 -3 3 -1 -4z"
          />
          <path
            d="M7546 945 c-3 -9 -2 -24 2 -32 8 -13 10 -13 16 2 3 9 2 24 -2 32 -8
13 -10 13 -16 -2z"
          />
          <path
            d="M8817 943 c5 -15 3 -16 -8 -5 -20 18 -39 14 -39 -9 0 -16 4 -19 20
-14 17 5 20 2 18 -20 -2 -22 -4 -24 -14 -11 -13 19 -29 22 -17 4 4 -7 6 -20 5
-30 -4 -20 14 -33 24 -17 4 8 3 9 -4 5 -7 -4 -12 -1 -12 7 0 11 7 13 23 9 19
-5 20 -3 9 10 -7 9 -9 19 -4 22 12 7 12 55 1 62 -5 3 -6 -3 -2 -13z"
          />
          <path d="M8996 947 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path
            d="M2255 930 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path d="M3268 913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3350 910 c0 -5 7 -6 17 -3 9 4 14 2 10 -3 -3 -6 3 -11 14 -11 10 -1
19 4 19 10 0 7 -13 14 -30 15 -16 1 -30 -2 -30 -8z"
          />
          <path
            d="M8600 906 c0 -22 43 -30 101 -20 76 14 64 29 -23 32 -65 2 -78 0 -78
-12z"
          />
          <path d="M8986 911 c-18 -7 -18 -8 4 -14 27 -7 39 -1 24 12 -5 5 -18 5 -28 2z" />
          <path
            d="M3235 885 c0 -14 4 -25 8 -25 5 0 6 -4 3 -9 -9 -14 18 -61 36 -61 11
0 15 -5 12 -15 -5 -12 3 -15 42 -14 27 0 43 3 36 6 -6 2 -9 10 -6 15 4 7 2 8
-5 4 -27 -17 -46 3 -45 46 1 39 1 39 -3 6 -3 -28 -8 -36 -23 -35 -10 1 -18 4
-18 7 2 18 -3 30 -10 26 -5 -3 -9 8 -10 24 0 22 4 30 16 31 14 0 13 2 -3 9
-29 13 -30 12 -30 -15z"
          />
          <path
            d="M3310 898 c0 -4 7 -8 15 -8 8 0 15 4 15 8 0 5 -7 9 -15 9 -8 0 -15
-4 -15 -9z"
          />
          <path d="M3421 894 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M7377 890 c16 -59 156 -60 160 -1 2 21 2 21 -20 1 -11 -11 -30 -21
-41 -22 -12 0 -28 -2 -36 -2 -8 -1 -25 9 -36 21 -26 28 -34 29 -27 3z"
          />
          <path
            d="M7631 895 c-1 -17 -3 -17 -11 -5 -9 13 -10 13 -11 0 -1 -8 0 -22 1
-30 1 -8 -2 -12 -6 -7 -4 4 -20 -4 -34 -18 -31 -30 -97 -65 -120 -64 -10 0 -9
3 5 9 16 7 17 9 3 9 -23 1 -33 -18 -13 -25 24 -10 107 15 133 39 33 31 65 85
59 100 -3 6 -6 3 -6 -8z"
          />
          <path
            d="M3513 885 c3 -6 2 -17 -4 -25 -5 -9 -9 -10 -9 -4 0 7 -7 14 -15 17
-12 5 -12 1 -4 -21 6 -15 7 -23 3 -20 -10 11 -47 -19 -50 -39 -2 -16 -1 -16
12 1 8 11 14 17 14 13 0 -14 40 14 56 39 14 20 15 27 4 37 -7 7 -10 7 -7 2z"
          />
          <path
            d="M7305 870 c-9 -14 13 -50 30 -50 8 0 15 -8 16 -17 0 -11 2 -13 6 -5
7 18 -25 64 -39 56 -8 -5 -9 -2 -5 9 7 18 2 23 -8 7z"
          />
          <path d="M3393 855 c-7 -8 -9 -16 -5 -19 4 -3 13 4 20 15 14 22 3 25 -15 4z" />
          <path d="M1983 853 c-24 -9 -13 -23 17 -23 20 0 30 5 30 15 0 15 -22 19 -47 8z" />
          <path
            d="M3135 840 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"
          />
          <path d="M3331 844 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M8891 833 c0 -25 1 -26 9 -8 12 27 12 35 0 35 -5 0 -10 -12 -9 -27z" />
          <path
            d="M8978 842 c-6 -22 -28 -26 -55 -9 -8 5 -13 4 -13 -2 0 -6 5 -11 11
-11 5 0 7 -5 3 -11 -3 -6 0 -15 7 -20 10 -6 3 -9 -20 -9 -26 0 -32 -3 -24 -11
17 -17 79 -2 109 26 15 14 22 25 17 25 -6 0 -16 -7 -23 -15 -7 -8 -17 -12 -22
-9 -5 3 -2 14 7 24 10 11 15 25 13 32 -3 7 -7 3 -10 -10z"
          />
          <path
            d="M3173 815 c0 -8 4 -12 9 -9 4 3 8 0 8 -6 0 -10 17 -18 68 -34 39 -13
23 10 -27 37 -57 31 -58 32 -58 12z m42 -15 c3 -5 1 -10 -4 -10 -6 0 -11 5
-11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"
          />
          <path d="M2693 725 c0 -44 2 -61 4 -37 2 23 2 59 0 80 -2 20 -4 1 -4 -43z" />
          <path d="M1822 648 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z" />
          <path d="M2050 644 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z" />
          <path
            d="M4327 653 c-4 -3 -7 -37 -7 -75 0 -54 3 -68 15 -68 12 0 15 15 15 75
0 69 -6 86 -23 68z"
          />
          <path
            d="M4770 645 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0
-15 -7 -15 -15z"
          />
          <path
            d="M4940 645 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2
-11 -4 -11 -13z"
          />
          <path
            d="M1705 615 c-8 -19 -22 -51 -30 -70 -13 -30 -13 -35 -1 -35 8 0 16 7
20 15 3 9 18 15 40 15 21 0 36 -6 40 -15 4 -13 36 -22 36 -11 0 20 -64 136
-75 136 -8 0 -22 -16 -30 -35z m45 -36 c0 -10 -7 -19 -15 -19 -16 0 -19 9 -9
34 8 20 24 11 24 -15z"
          />
          <path
            d="M4200 580 l0 -70 51 0 c57 0 66 23 11 28 -42 4 -44 32 -2 32 17 0 30
5 30 10 0 6 -13 10 -30 10 -23 0 -30 4 -30 20 0 16 7 20 35 20 19 0 35 5 35
10 0 6 -22 10 -50 10 l-50 0 0 -70z"
          />
          <path
            d="M5780 643 c-29 -11 -50 -36 -50 -60 0 -55 47 -91 95 -73 33 13 33 34
0 26 -34 -9 -65 9 -65 38 0 33 24 50 60 42 34 -6 40 8 11 24 -21 11 -28 11
-51 3z"
          />
          <path
            d="M6000 581 c0 -67 1 -69 28 -73 42 -6 58 1 71 29 17 36 -8 73 -49 73
-23 0 -30 4 -30 20 0 11 -4 20 -10 20 -6 0 -10 -30 -10 -69z m75 -21 c0 -18
-6 -26 -21 -28 -26 -4 -40 24 -23 45 18 21 44 11 44 -17z"
          />
          <path
            d="M6130 580 c0 -50 4 -70 13 -70 9 0 12 20 12 70 0 49 -4 70 -12 70 -9
0 -13 -21 -13 -70z"
          />
          <path
            d="M6352 644 c-17 -8 -5 -24 19 -24 16 0 19 -7 19 -55 0 -42 3 -55 15
-55 12 0 15 13 15 55 0 49 2 55 21 55 12 0 19 5 17 13 -5 12 -82 20 -106 11z"
          />
          <path
            d="M6557 598 l-23 -53 -19 48 c-10 26 -24 47 -32 47 -16 0 -13 -16 18
-88 25 -58 45 -52 75 22 27 66 29 76 14 76 -6 0 -21 -24 -33 -52z"
          />
          <path
            d="M1966 624 c-3 -8 -4 -26 -1 -40 3 -13 7 -35 10 -49 4 -19 12 -25 30
-25 28 0 34 15 10 24 -20 7 -19 52 2 60 14 6 14 9 -5 26 -26 24 -38 25 -46 4z"
          />
          <path
            d="M4611 619 c-8 -14 -9 -24 -3 -28 6 -3 12 -22 14 -41 2 -27 8 -36 26
-38 25 -4 30 13 7 22 -8 3 -15 17 -15 31 0 16 6 25 15 25 21 0 19 12 -5 33
-25 21 -23 21 -39 -4z"
          />
          <path
            d="M4991 619 c-8 -14 -9 -24 -3 -28 6 -3 12 -22 14 -41 2 -27 8 -36 26
-38 22 -3 30 12 12 23 -14 9 -13 52 2 57 8 3 4 12 -10 26 -27 27 -24 27 -41 1z"
          />
          <path
            d="M9100 625 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0
-15 -7 -15 -15z"
          />
          <path
            d="M9157 633 c-4 -3 -7 -37 -7 -75 0 -54 3 -68 15 -68 12 0 15 15 15 75
0 69 -6 86 -23 68z"
          />
          <path
            d="M9210 566 c0 -44 4 -76 10 -76 6 0 10 30 10 69 0 39 -4 73 -10 76 -6
4 -10 -22 -10 -69z"
          />
          <path
            d="M3100 560 l0 -70 45 0 c53 0 85 25 85 68 0 47 -33 72 -94 72 l-36 0
0 -70z m74 40 c20 -7 26 -16 26 -40 0 -24 -6 -33 -26 -40 -14 -6 -30 -10 -35
-10 -10 0 -13 83 -2 93 8 9 7 9 37 -3z"
          />
          <path
            d="M7193 618 c2 -7 12 -39 21 -71 21 -71 42 -73 65 -7 l15 45 15 -48
c20 -65 39 -58 67 26 21 61 21 68 6 65 -9 -2 -21 -19 -27 -40 -15 -53 -21 -54
-35 -3 -15 55 -34 58 -50 8 -19 -57 -26 -59 -39 -9 -7 31 -17 46 -27 46 -9 0
-14 -6 -11 -12z"
          />
          <path
            d="M8359 612 c-15 -13 -22 -30 -22 -52 0 -62 75 -93 121 -50 66 61 -29
158 -99 102z m72 -12 c30 -17 26 -67 -7 -82 -23 -11 -29 -10 -45 10 -19 24
-16 49 9 70 19 15 19 15 43 2z"
          />
          <path
            d="M8580 560 c0 -56 3 -70 15 -70 11 0 15 11 15 35 0 23 6 38 16 42 20
7 35 -14 32 -46 -2 -13 3 -26 10 -28 8 -3 12 9 12 41 0 48 -22 72 -54 60 -12
-4 -16 0 -16 15 0 12 -6 21 -15 21 -12 0 -15 -14 -15 -70z"
          />
          <path
            d="M8960 560 l0 -70 43 0 c57 0 82 18 71 51 -4 13 -7 32 -5 42 4 31 -18
47 -65 47 l-44 0 0 -70z m78 28 c3 -13 -3 -18 -22 -18 -20 0 -26 5 -26 21 0
15 5 20 22 17 13 -2 24 -11 26 -20z m7 -58 c0 -9 -11 -16 -27 -18 -23 -3 -28
1 -28 18 0 17 5 21 28 18 16 -2 27 -9 27 -18z"
          />
          <path
            d="M1830 565 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55 -5
0 -10 -25 -10 -55z"
          />
          <path
            d="M1880 563 c0 -40 4 -53 15 -53 11 0 15 11 15 35 0 22 6 38 15 41 26
10 16 31 -15 31 -30 0 -30 -1 -30 -54z"
          />
          <path d="M2050 566 c0 -44 3 -56 16 -56 12 0 14 10 12 52 -4 74 -28 77 -28 4z" />
          <path
            d="M2105 611 c-3 -2 -5 -26 -5 -53 0 -36 4 -48 15 -48 11 0 15 11 15 35
0 23 6 38 15 42 23 8 32 -7 34 -59 2 -34 20 -18 23 20 2 29 7 37 23 37 16 0
21 -8 23 -37 4 -53 22 -48 22 6 0 54 -19 74 -55 58 -13 -6 -27 -7 -30 -3 -5 9
-72 11 -80 2z"
          />
          <path
            d="M2322 613 c-7 -3 -18 -16 -23 -30 -15 -39 13 -75 53 -71 17 2 33 9
36 16 3 9 -4 12 -23 10 -16 -2 -30 2 -32 9 -3 8 6 10 31 6 32 -5 36 -3 36 15
0 33 -44 59 -78 45z m48 -34 c0 -5 -12 -9 -26 -9 -22 0 -24 2 -14 14 12 15 40
11 40 -5z"
          />
          <path
            d="M3367 598 c-4 -12 -2 -27 3 -32 4 -6 10 -24 12 -41 2 -22 9 -31 26
-33 12 -2 22 1 22 7 0 6 -7 11 -15 11 -10 0 -15 10 -15 30 0 20 5 30 15 30 20
0 19 6 -5 30 -26 26 -36 25 -43 -2z"
          />
          <path
            d="M4390 600 c-46 -46 2 -108 64 -84 25 9 19 27 -7 21 -12 -4 -28 -2
-36 2 -9 6 -1 11 28 16 22 4 41 11 41 16 0 15 -39 49 -55 49 -8 0 -24 -9 -35
-20z m60 -20 c0 -5 -11 -10 -25 -10 -14 0 -25 5 -25 10 0 6 11 10 25 10 14 0
25 -4 25 -10z"
          />
          <path
            d="M4510 600 c-46 -46 2 -108 64 -84 25 9 19 27 -7 21 -29 -8 -50 6 -45
29 2 12 12 19 28 20 43 2 46 4 26 19 -27 20 -42 19 -66 -5z"
          />
          <path
            d="M4718 612 c-26 -3 -28 -6 -28 -53 0 -37 4 -49 15 -49 10 0 15 11 15
35 0 21 6 37 16 43 24 14 13 27 -18 24z"
          />
          <path
            d="M4776 613 c-3 -3 -6 -28 -6 -55 0 -36 4 -48 15 -48 11 0 15 12 15 49
0 47 -9 68 -24 54z"
          />
          <path
            d="M4842 604 c-28 -20 -30 -69 -3 -84 28 -15 57 -12 72 6 11 14 10 16
-11 14 -45 -4 -51 -1 -48 23 2 16 10 22 28 23 43 2 46 4 26 19 -25 19 -36 19
-64 -1z"
          />
          <path
            d="M4947 613 c-11 -10 -8 -103 3 -103 6 0 10 10 11 23 0 12 2 32 3 44 3
26 -7 47 -17 36z"
          />
          <path
            d="M5070 603 c1 -10 7 -29 15 -43 20 -36 18 -57 -6 -63 -24 -7 -16 -27
10 -27 23 0 32 12 59 79 25 60 26 71 12 71 -5 0 -17 -17 -26 -37 l-16 -38 -15
38 c-16 39 -33 49 -33 20z"
          />
          <path
            d="M7518 603 c-2 -33 4 -78 13 -95 10 -19 49 -25 49 -8 0 6 -7 10 -15
10 -10 0 -15 10 -15 30 0 20 5 30 15 30 20 0 19 6 -5 30 -25 25 -40 26 -42 3z"
          />
          <path
            d="M8501 599 c-8 -14 -9 -24 -3 -28 6 -3 12 -22 14 -41 2 -27 8 -36 26
-38 26 -4 28 3 7 24 -8 9 -15 24 -15 35 0 10 7 19 15 19 20 0 19 6 -5 30 -24
24 -22 25 -39 -1z"
          />
          <path
            d="M5885 600 c-7 -11 -1 -13 33 -10 12 1 22 -3 22 -9 0 -6 -10 -11 -23
-11 -25 0 -47 -17 -47 -37 0 -19 31 -31 68 -26 29 5 32 8 32 42 0 20 -5 42
-12 49 -15 15 -64 16 -73 2z m55 -60 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10
0 6 9 10 20 10 11 0 20 -4 20 -10z"
          />
          <path
            d="M6193 598 c-37 -48 -7 -94 60 -89 10 0 17 7 14 14 -2 7 -15 11 -30 9
-15 -2 -27 1 -27 7 0 6 16 11 35 11 37 0 42 9 25 41 -12 22 -62 26 -77 7z m57
-18 c0 -5 -12 -10 -26 -10 -14 0 -23 4 -19 10 3 6 15 10 26 10 10 0 19 -4 19
-10z"
          />
          <path
            d="M3273 593 c-22 -8 -14 -23 12 -23 34 0 32 -18 -2 -22 -22 -2 -28 -8
-28 -28 0 -23 4 -25 43 -26 l42 -2 0 44 c0 52 -26 74 -67 57z m37 -68 c0 -8
-7 -15 -15 -15 -16 0 -20 12 -8 23 11 12 23 8 23 -8z"
          />
          <path
            d="M3468 592 c-29 -6 -20 -22 12 -22 38 0 40 -18 3 -22 -22 -2 -28 -8
-28 -28 0 -22 5 -25 43 -28 l42 -3 0 38 c0 21 -4 43 -8 49 -9 13 -41 21 -64
16z m42 -73 c0 -5 -9 -9 -20 -9 -22 0 -27 16 -7 23 15 5 27 -1 27 -14z"
          />
          <path
            d="M7423 593 c-22 -8 -14 -23 11 -23 38 0 41 -18 4 -22 -28 -2 -33 -7
-33 -28 0 -22 5 -25 43 -28 l42 -3 0 45 c0 35 -5 48 -19 56 -21 11 -29 11 -48
3z m42 -63 c3 -6 -1 -13 -10 -16 -19 -8 -30 0 -20 15 8 14 22 14 30 1z"
          />
          <path
            d="M7623 590 c-30 -12 -38 -46 -18 -76 13 -20 23 -25 48 -22 34 3 36 22
2 22 -11 1 -20 6 -20 11 0 10 5 12 43 14 27 1 28 15 2 41 -22 22 -25 23 -57
10z m47 -30 c0 -5 -12 -10 -26 -10 -14 0 -23 4 -19 10 3 6 15 10 26 10 10 0
19 -4 19 -10z"
          />
          <path
            d="M7724 591 c-2 -2 -4 -26 -4 -53 0 -57 23 -64 28 -9 2 18 10 35 18 38
24 9 16 28 -12 28 -14 0 -28 -2 -30 -4z"
          />
          <path
            d="M8720 580 c-25 -25 -26 -52 -2 -73 21 -19 49 -22 72 -7 15 10 11 12
-27 14 -33 2 -23 21 11 21 37 0 43 18 17 44 -26 26 -46 26 -71 1z m60 -20 c0
-5 -12 -10 -26 -10 -14 0 -23 4 -19 10 3 6 15 10 26 10 10 0 19 -4 19 -10z"
          />
          <path
            d="M8830 544 c0 -30 5 -54 10 -54 6 0 10 13 10 29 0 19 8 35 22 45 25
18 19 28 -17 32 -24 3 -25 0 -25 -52z"
          />
          <path
            d="M9100 545 c0 -41 3 -56 13 -52 7 2 12 22 12 52 0 30 -5 50 -12 53
-10 3 -13 -12 -13 -53z"
          />
          <path
            d="M9273 593 c-7 -2 -13 -15 -13 -29 0 -17 7 -25 25 -30 33 -8 33 -28 0
-22 -35 7 -42 -10 -9 -18 56 -14 88 39 35 57 -33 12 -34 31 -1 22 24 -6 27 12
4 21 -18 7 -23 7 -41 -1z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
